// extracted by mini-css-extract-plugin
export default {"container":"container-oCVO7Plk"};